/**
 * Created by cahyo on 09/02/19.
 */

import Constant from "../../config/Constant";
import moment from "moment";

export default (param: Date, POSTFormat: boolean = false, fmt: string = '') => {
  const {POST_PUT_FORMAT_DATE, PREVIEW_FORMAT_DATE} = Constant;

  return moment(param).locale(POSTFormat ? 'EN' : 'ID')
    .format(fmt ? fmt : POSTFormat ? POST_PUT_FORMAT_DATE : PREVIEW_FORMAT_DATE);
}
